export default "__VITE_ASSET__DdifDrG3__"